module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.11122/js/img/CRM.svg"